import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import ThreeStateToggleButton from '../CommonComponents/ThreeStateToggleButton'
import { Loader, Panel } from 'rsuite';
import CheckboxComponent from '../CommonComponents/CheckboxComponent'
import { parseFullAddress } from '../../redux/actions/upload';
import { getParsedAddress } from '../../services/helper';
import { useDispatch } from 'react-redux';

const SupplierCheckInfo = ({ checkInfo, childPaymentInfo, columns, onChangeCheckInfo, onSave, onCancel, isLoading = false, isDisabledButtons = false }) => {
    const dispatch = useDispatch()
    const paymentTermsOptions = [...Array(91)].map((_, i) => i);
    const supplier_types = ['related', 'master'];

    const [relatedCheckInfo, setRelatedCheckInfo] = useState({})
    const [masterCheckInfo, setMasterCheckInfo] = useState({})
    const [isParsingAddress, setIsParsingAddress] = useState(false)

    useEffect(() => {
        setRelatedCheckInfo(childPaymentInfo || {})
        setMasterCheckInfo(checkInfo || {})
    }, [checkInfo, childPaymentInfo])

    const handleChangeVendorAddress = (value) => {
        onChangeCheckInfo(columns[1].name, {
            label: value,
            value: value
        })
    }

    const PanelHeader = (headerText) => {
        return (
            <h4 className='mb-0'> {headerText} </h4>
        )
    }

    const parseAddress = async () => {
        if (checkInfo?.checkAddress1?.value) {
            try {
                setIsParsingAddress(true)
                const addressResult = await dispatch(parseFullAddress(checkInfo?.checkAddress1?.value))
                const parsedResult = getParsedAddress(addressResult)
                onChangeCheckInfo('parseAddress', parsedResult)
                setIsParsingAddress(false)
            } catch (err) {
                setIsParsingAddress(false)
            }
        }
    }

    return (
        <div className='border border-1 card supply-check-acceptance related-supply-check-acceptance bg-white mt-0'>
            {/* <Panel header={PanelHeader('Check Acceptance Information')} className={`card supply-check-acceptance related-supply-check-acceptance bg-white mt-0`} defaultExpanded={true} collapsible bordered> */}
            <div className="card-content d-flex flex-column flex-lg-row gap-4 gap-sm-5">
                {supplier_types.map((value, index) => (
                    <div key={index} className={`${value}-supplier-card-content w-auto`}>
                        <div className="item flex-wrap">
                            <h3 className='supplier-card-content-header text-black fw-bold pt-3 pb-3'> {value === 'related' ? 'Related Supplier Information' : 'Master Supplier Information'} </h3>
                            {value === 'master' && (
                                <div className='ms-auto'>
                                    <button type="button" className="card-edit-button me-0 p-2 ps-3 pe-3 ps-sm-4 pe-sm-4 me-2 bg-light-gray text-white rounded width-100" onClick={() => { onCancel('check') }}>Cancel</button>
                                    <button type="button" className="card-edit-button me-0 p-2 ps-3 pe-3 ps-sm-4 pe-sm-4 btn-green rounded width-100" onClick={onSave} disabled={isLoading || isDisabledButtons}>Save</button>
                                </div>
                            )}
                        </div>
                        <div className="item">
                            <h4 className='fw-bold text-black toggle-item-text'>Do they accept Check Payments?</h4>
                            <ThreeStateToggleButton checked={value === 'related' ? relatedCheckInfo?.isAcceptCheckPayments : masterCheckInfo?.[columns[0].name]?.value} isDisabled={value === 'related' ? true : false} onChange={(checked) => onChangeCheckInfo(columns[0].name, { label: `${checked}`, value: checked })} />
                        </div>

                        {
                            (value === 'related' ? relatedCheckInfo?.isAcceptCheckPayments : masterCheckInfo?.[columns[0].name]?.value) && (
                                <>
                                    <div className='item'>
                                        <CheckboxComponent
                                            label='Check payment address varies from company address'
                                            disabled={value === 'related' ? true : false}
                                            checked={value === 'related' ? relatedCheckInfo?.isAcceptPaymentAddressFromCompanyAddress || false : masterCheckInfo?.[columns[1].name]?.value || false}
                                            onChange={handleChangeVendorAddress}
                                        />
                                    </div>
                                    <div className="item">
                                        <h4 className="item-name">Address Line1:</h4>
                                        <input
                                            type="text"
                                            className="search-input"
                                            value={value === 'related' ? relatedCheckInfo?.checkAddress1 || '' : masterCheckInfo?.[columns[2].name]?.value || ''}
                                            disabled={value === 'related' ? true : !masterCheckInfo?.[columns[1].name]?.value}
                                            onChange={(e) => onChangeCheckInfo(columns[2].name, { label: e.target.value, value: e.target.value })}
                                        />
                                        {value === 'master' && masterCheckInfo?.checkAddress1?.value && masterCheckInfo?.[columns[1].name]?.value && (
                                            <div className="position-relative text-center ms-3" style={{ height: '48px' }}>
                                                {isParsingAddress && <Loader size="sm" className="top-33 position-absolute start-0 end-0" />}
                                                <button
                                                    type="button"
                                                    className={`${isParsingAddress ? 'bg-light ' : ''}h-100 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 fs-6 bg-dark-blue rounded text-white`}
                                                    onClick={parseAddress}
                                                    disabled={!masterCheckInfo?.[columns[1].name]?.value}
                                                >
                                                    Parse Address
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    <div className="item">
                                        <h4 className="item-name">Address Line2:</h4>
                                        <input
                                            type="text"
                                            className="search-input"
                                            value={value === 'related' ? relatedCheckInfo?.checkAddress2 || '' : masterCheckInfo?.[columns[3].name]?.value || ''}
                                            disabled={value === 'related' ? true : !masterCheckInfo?.[columns[1].name]?.value}
                                            onChange={(e) => onChangeCheckInfo(columns[3].name, { label: e.target.value, value: e.target.value })}
                                        />
                                    </div>
                                    <div className="item">
                                        <h4 className="item-name">City:</h4>
                                        <input
                                            type="text"
                                            className="search-input"
                                            value={value === 'related' ? relatedCheckInfo?.checkCity || '' : masterCheckInfo?.[columns[4].name]?.value || ''}
                                            disabled={value === 'related' ? true : !masterCheckInfo?.[columns[1].name]?.value}
                                            onChange={(e) => onChangeCheckInfo(columns[4].name, { label: e.target.value, value: e.target.value })}
                                        />
                                    </div>
                                    <div className="item">
                                        <h4 className="item-name">State:</h4>
                                        <input
                                            type="text"
                                            className="search-input"
                                            value={value === 'related' ? relatedCheckInfo?.checkState || '' : masterCheckInfo?.[columns[5].name]?.value || ''}
                                            disabled={value === 'related' ? true : !masterCheckInfo?.[columns[1].name]?.value}
                                            onChange={(e) => onChangeCheckInfo(columns[5].name, { label: e.target.value, value: e.target.value })}
                                        />
                                    </div>
                                    <div className="item">
                                        <h4 className="item-name">Zip:</h4>
                                        <input
                                            type="text"
                                            className="search-input"
                                            value={value === 'related' ? relatedCheckInfo?.checkCountry || '' : masterCheckInfo?.[columns[6].name]?.value || ''}
                                            disabled={value === 'related' ? true : !masterCheckInfo?.[columns[1].name]?.value}
                                            onChange={(e) => onChangeCheckInfo(columns[6].name, { label: e.target.value, value: e.target.value })}
                                        />
                                    </div>
                                    <div className="item">
                                        <h4 className="item-name">Country:</h4>
                                        <input
                                            type="text"
                                            className="search-input check-zip-input"
                                            value={value === 'related' ? relatedCheckInfo?.checkZip || '' : masterCheckInfo?.[columns[7].name]?.value || ''}
                                            disabled={value === 'related' ? true : !masterCheckInfo?.[columns[1].name]?.value}
                                            onChange={(e) => onChangeCheckInfo(columns[7].name, { label: e.target.value, value: e.target.value })}
                                        />
                                    </div>
                                    <div className="item">
                                        <h4 className='fw-bold text-black toggle-item-text'>Cash Payment Terms</h4>
                                        <ThreeStateToggleButton checked={value === 'related' ? relatedCheckInfo?.isAcceptCashPaymentTerms : masterCheckInfo?.[columns[8].name]?.value} isDisabled={value === 'related' ? true : false} onChange={(checked) => onChangeCheckInfo(columns[8].name, { label: `${checked}`, value: checked })} />
                                    </div>

                                    {
                                        (value === 'related' ? relatedCheckInfo?.isAcceptCashPaymentTerms : masterCheckInfo?.[columns[8].name]?.value) && (
                                            <div className="item payment-terms">
                                                <div className='d-flex align-items-sm-center align-items-start w-100 g-0 flex-column flex-sm-row'>
                                                    <span className='label'> Payment Terms </span>
                                                    <Select
                                                        className="cash-payment-terms-selector ms-0 ms-sm-auto h4 mb-0"
                                                        placeholder="Select..."
                                                        value={value === 'related' ? {
                                                            label: relatedCheckInfo?.cashPaymentTermsValue || 'Upon Receipt',
                                                            value: relatedCheckInfo?.cashPaymentTermsValue || 'Upon Receipt'
                                                        } : masterCheckInfo?.[columns[9].name]}
                                                        isDisabled={value === 'related' ? true : false}
                                                        onChange={(item) => onChangeCheckInfo(columns[9].name, item)}
                                                        options={
                                                            paymentTermsOptions.map((element) => (
                                                                {
                                                                    label: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days'),
                                                                    value: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days')
                                                                }
                                                            ))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }

                                    <div className="item">
                                        <h4 className='fw-bold text-black toggle-item-text'>Do they offer cash Discount?</h4>
                                        <ThreeStateToggleButton checked={value === 'related' ? relatedCheckInfo?.isAcceptCashDiscount : masterCheckInfo?.[columns[10].name]?.value} isDisabled={value === 'related' ? true : false} onChange={(checked) => onChangeCheckInfo(columns[10].name, { label: `${checked}`, value: checked })} />
                                    </div>
                                    {
                                        (value === 'related' ? relatedCheckInfo?.isAcceptCashDiscount : masterCheckInfo?.[columns[10].name]?.value) && (
                                            <>
                                                <div className="item cash-discount d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                                                    <h4 className='text-black fw-normal mb-0'> Cash Discount: </h4>
                                                    <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                                                        <div className='d-flex'>
                                                            <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                                                <Select
                                                                    className="processing-fee-dropdown cash-discount-type-selector h4 mb-0"
                                                                    placeholder="Select..."
                                                                    value={value === 'related' ? {
                                                                        label: !relatedCheckInfo?.cashDiscountType ? '%' : relatedCheckInfo?.cashDiscountType === 'Percentage' ? '%' : '$',
                                                                        value: relatedCheckInfo?.cashDiscountType || 'Percentage'
                                                                    } : masterCheckInfo?.[columns[11].name]}
                                                                    options={
                                                                        [
                                                                            {
                                                                                label: '%',
                                                                                value: 'Percentage',
                                                                            },
                                                                            {
                                                                                label: '$',
                                                                                value: 'Dollar',
                                                                            },
                                                                        ]
                                                                    }
                                                                    isDisabled={value === 'related' ? true : false}
                                                                    onChange={(item) => onChangeCheckInfo(columns[11].name, item, 'discounttype')}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="search-input cash-discount-value-input"
                                                                    disabled={value === 'related' ? true : false}
                                                                    onChange={(e) => onChangeCheckInfo(columns[12].name, { label: e.target.value, value: e.target.value }, checkInfo?.[columns[11].name]?.value === 'Dollar' ? 'currency' : 'percent')}
                                                                    value={checkInfo?.[columns[12].name]?.value || ''}
                                                                    placeholder={(value === 'related' ? relatedCheckInfo?.cashDiscountType === 'Dollar' : masterCheckInfo?.[columns[11].name]?.value === 'Dollar') ? '1,234.00' : '12.50'}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }
                                </>
                            )
                        }
                        {(index === 0 && <hr className='d-block d-lg-none' />)}
                    </div>
                ))}
            </div>
            {/* </Panel> */}
        </div>
    )
}
export default SupplierCheckInfo